import { createFileRoute } from "@tanstack/react-router";
import { ApiPage } from "../pages/ApiPage";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import { buildCompleteHead } from "../utils/seo";
import { LangProvider } from "../contexts/LangContext";

export const Route = createFileRoute("/uzbek-transliteration-api")({
  head: () => {
    const seoData = buildCompleteHead(
      "default",
      "home",
      "https://lotin.uz/uzbek-transliteration-api",
      "/uzbek-transliteration-api",
      "/uzbek-transliteration-api",
    );
    return {
      meta: [{ title: "API Reference — Lotin.uz" }, ...seoData.meta],
      links: seoData.links,
      htmlProps: { lang: "uz-Latn" },
    };
  },
  component: UzbekTransliterationApi,
});

function UzbekTransliterationApi() {
  const { i18n } = useTranslation();

  useEffect(() => {
    document.documentElement.lang = "uz-Latn";
    // Guard for SSR: only call changeLanguage if it exists
    if (i18n?.changeLanguage) {
      i18n.changeLanguage("default");
    }
    document.title = "API Reference — Lotin.uz";
  }, [i18n]);

  return (
    <LangProvider lang={"uz-Latn"}>
      <ApiPage lang="uz-Latn" />
    </LangProvider>
  );
}
